import type { IListResponse, ISite } from '@xbl/types'
import { request } from '@umijs/max'

/** 获取诗文详情 GET /backend/site/:id */
export async function siteDetail(options?: Record<string, any>) {
  return request<{
    data: ISite
  }>('/backend/site/:id', {
    method: 'GET',
    ...options
  })
}

/** 获取是否有重名 GET /backend/site/getName */
export async function siteName(
  params: {
    title?: string
    subtitle?: string
    name?: string
    id?: number
  },
  options?: Record<string, any>
) {
  return request<{
    data: ISite
  }>('/backend/site/getName', {
    method: 'GET',
    params,
    ...options
  })
}

/** 获取诗文列表 GET /backend/site/list */
export async function siteList(
  params: {
    // query
    /** 当前的页码 */
    current?: number
    /** 页面的容量 */
    pageSize?: number
  },
  options?: Record<string, any>
) {
  return request<IListResponse<ISite>>('/backend/site/list', {
    method: 'GET',
    params: {
      ...params
    },
    ...options
  })
}

/** 添加/编辑诗文 POST /api/site/add */
export async function siteAdd(body: ISite, options?: Record<string, any>) {
  return request<{ data: ISite, status: number, message: string }>('/backend/site/add', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 更新诗文剧照 POST /api/site/editCover */
export async function siteEditCover(body: { id?: number, cover?: number }, options?: Record<string, any>) {
  return request<{ data: ISite, status: number, message: string }>('/backend/site/editCover', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 删除诗文 DELETE /api/site/delete */
export async function siteDelete(options?: Record<string, any>) {
  return request<Record<string, any>>('/backend/site/delete', {
    method: 'DELETE',
    ...options
  })
}
